import type { Logger } from '#src/assets/lib/logger.ts'

export function dispatchConsentEvents({
  consents,
  log,
}: {
  consents: Record<string, boolean>
  log: Logger['log']
}): void {
  log('Dispatching consent events:', consents)

  Object.keys(consents).forEach(category => {
    if (category === 'necessary') {
      return
    }

    const isConsented = consents[category]
    const eventName = `lcc.cookie.${category}.${isConsented ? 'accepted' : 'rejected'}`

    window.dispatchEvent(
      new Event(eventName, {
        bubbles: true,
        cancelable: true,
      }),
    )
    log(`Dispatched event: ${eventName}`)
  })

  window.dispatchEvent(
    new Event('lcc.cookie.scripts-processed', {
      bubbles: true,
      cancelable: true,
    }),
  )
  log('Dispatched event: lcc.cookie.scripts-processed')
}
